<template>
  <el-form-item :label="title" :required="isRequire">
    <el-date-picker
      v-model="value"
      type="date"
      format="dd MMM yyyy"
      value-format="yyyy-MM-dd"
      placeholder="Choose Date"
      :picker-options="pickerOptions"
    ></el-date-picker>
  </el-form-item>
</template>

<script>
import { parse, save } from '../providers/store-parser'

export default {
  name: 'InputDatePicker',
  props: {
    title: {
      type: String,
      required: true
    },
    getter: {
      type: String,
      required: true
    },
    setter: {
      type: String,
      required: true
    },
    isRequire: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    value: {
      get () {
        return parse(this.getter)
      },
      set (val) {
        save(this.setter, val)
      }
    }
  },
  data () {
    return {
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // },
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Tomorrow',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '1 Week Later',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }, {
          text: '2 Week Later',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 14)
            picker.$emit('pick', date)
          }
        }, {
          text: '1 Month Later',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  }
}
</script>
